// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"12c7cd12","455":"993cf05f","977":"49f20798"}[chunkId] + ".chunk.js";
};